import { render, staticRenderFns } from "./MyCoursesSidebarSwitch.vue?vue&type=template&id=a28dd1e8&"
import script from "./MyCoursesSidebarSwitch.vue?vue&type=script&lang=js&"
export * from "./MyCoursesSidebarSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a28dd1e8')) {
      api.createRecord('a28dd1e8', component.options)
    } else {
      api.reload('a28dd1e8', component.options)
    }
    module.hot.accept("./MyCoursesSidebarSwitch.vue?vue&type=template&id=a28dd1e8&", function () {
      api.rerender('a28dd1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/MyCoursesSidebarSwitch.vue"
export default component.exports